import './mixin_base';
import './drentsemusea-maps';
import './fix_calendar';
import '../sass/drentsemusea.scss';

console.log('Assets of Drentse Musea')
